<!-- @format -->

<template>
    <div class="gst-order-confirmation_earn-disclaimer d-flex pa-3">
        <BaseIcon
            class="gst-order-confirmation_earn-disclaimer_icon"
            symbol-id="icons--info-filled"
            :width="24"
            :height="24" />
        <span class="gst-order-confirmation_earn-disclaimer_info">
            {{ $t('info') }}
            <template v-if="ENGLISH_LOCALES.includes(locale)">
                {{ $t('infoLink') }}
            </template>
            <template v-else>
                <a
                    :href="tenantUrlsConstants.customerService"
                    target="_blank">
                    {{ $t('infoLink') }}
                </a>
            </template>
        </span>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import tenantUrlsConstants from '@tenant/app/utils/constants/tenantUrls';
import { ENGLISH_LOCALES } from '@tenant/app/utils/constants/i18n';

export default {
    name: 'OrderConfirmationPointsInformation',
    i18nOptions: {
        namespaces: 'shared',
        keyPrefix: 'components.bonusPoints.bonusPointsCartCheckoutConfirmation',
    },
    data: () => ({
        tenantUrlsConstants,
        ENGLISH_LOCALES,
    }),
    computed: {
        ...mapGetters({
            locale: 'appState/getLocale',
        }),
    },
};
</script>

<style lang="scss" scoped>
@import '@scssMixins';
@import '@scssVariables';

.gst-order-confirmation_earn-disclaimer {
    background-color: theme-color('quinary');
    gap: theme-spacing(2);

    .gst-order-confirmation_earn-disclaimer_icon {
        color: theme-color('tertiary');
        flex: none;
    }

    .gst-order-confirmation_earn-disclaimer_info {
        line-height: 20px;
        color: theme-color('tertiary');
        font-size: font-size('s');
        font-weight: font-weight('regular');
        letter-spacing: -0.412px;

        @include mobile-only {
            font-size: font-size('xxs');
        }
    }
}
</style>
